import { render, staticRenderFns } from "./foolproof.vue?vue&type=template&id=42bdf0bd&scoped=true"
import script from "./foolproof.vue?vue&type=script&lang=js"
export * from "./foolproof.vue?vue&type=script&lang=js"
import style0 from "./foolproof.vue?vue&type=style&index=0&id=42bdf0bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bdf0bd",
  null
  
)

export default component.exports